import axios from '../api/BaseURL';
import authHeader from './auth-header';

class areaRelatedAPI {
  // Area type create
  createArea(data) {
    return axios.post('/area/add', data, { headers: authHeader() });
  }

  // list
  getList() {
    return axios.get('/area/list', { headers: authHeader() });
  }

  // Area type update

  // Area type delete
  deleteArea(id) {
    return axios.delete('/area/delete', {
      headers: authHeader(),
      data: {
        id: id,
      },
    });
  }

  // change status
  changeStatus(id) {
    return axios.put(
      '/area/changeStatus',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    );
  }

  // Area type update
  updateArea(data) {
    return axios.put('/area/update', data, {
      headers: authHeader(),
    });
  }

  // district list
  districtList() {
    return axios.get('/location/districtList', { headers: authHeader() });
  }

  // details district by ID
  districtDetails(id) {
    return axios.get('/location/getDistrictById/' + id, {
      headers: authHeader(),
    });
  }
  // details  
  districtWiseArea(id) {
    return axios.get('/area/areaDetailsByDistrictId/' + id, {
      headers: authHeader(),
    });
  }
}
export default new areaRelatedAPI();
